<template>
  <Head title="Menu" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div>
        <Breadcrumbs
          :breadcrumbs="[
            { name: 'Dashboard', href: route('dashboard') },
            { name: 'Menu', href: route('menus.index') },
          ]"
        />

        <div class="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
          <div class="order-2 col-span-1 space-y-6 lg:order-1">
            <div class="bg-white border border-gray-200 shadow-lg rounded-xl">
              <div
                class="px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-xl sm:px-6 sm:py-4"
              >
                <h2
                  class="flex items-center text-lg font-bold text-white sm:text-xl"
                >
                  <i class="mr-2 fa-solid fa-bars sm:mr-3"></i>
                  {{ form.id ? "Edit Menu" : "Tambah Menu" }}
                </h2>
              </div>
              <div class="p-4 sm:p-6">
                <form class="space-y-4" @submit.prevent="submit">
                  <!-- Input Fields -->
                  <InputField
                    label="Nama Menu"
                    icon="pen"
                    v-model.capitalize="form.namamenu"
                  />
                  <InputError :message="form.errors.namamenu" class="mt-2" />
                  <InputField
                    label="Nama Route"
                    icon="pen"
                    v-model="form.linkurl"
                  />
                  <InputError :message="form.errors.linkurl" class="mt-2" />
                  <InputLabel
                    for="mainmenu"
                    value="Is Main Menu?"
                    class="mb-2"
                  />
                  <select
                    name="ismain"
                    v-model="form.ismain"
                    class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                  >
                    <option value="0">🏠 Main Menu (Parent)</option>
                    <optgroup label="📂 Sub Menu (Child of:)">
                      <option
                        v-for="ismainmenu in isMain.data"
                        :key="ismainmenu.id"
                        :value="ismainmenu.id"
                      >
                        📄 {{ ismainmenu.namamenu }}
                      </option>
                    </optgroup>
                  </select>
                  <InputError :message="form.errors.ismain" class="mt-2" />
                  <InputLabel
                    for="activepage"
                    value="Active Page"
                    class="mb-2"
                  />
                  <select
                    name="isactive"
                    v-model="form.isactive"
                    class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                  >
                    <option value=""></option>
                    <option value="0">Tidak</option>
                    <option value="1">Iya</option>
                  </select>
                  <InputError :message="form.errors.isactive" class="mt-2" />

                  <InputField
                    label="Icon Menu"
                    icon="pen"
                    v-model="form.icon_main"
                  />
                  <InputError :message="form.errors.icon_main" class="mt-2" />

                  <!-- Submit Button -->
                  <div class="pt-4">
                    <PrimaryBtn
                      :disabled="form.processing"
                      class="w-full px-4 py-2.5 text-sm font-semibold text-white bg-indigo-600 border border-transparent rounded-lg shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                    >
                      <i class="mr-2 fa-solid fa-floppy-disk"></i>
                      {{ form.processing ? "Menyimpan..." : "Simpan" }}
                    </PrimaryBtn>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="order-1 col-span-1 lg:col-span-2 lg:order-2">
            <!-- Header Section -->
            <div class="mb-4 sm:mb-6">
              <div
                class="flex flex-col sm:flex-row sm:items-center sm:justify-between"
              >
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">
                    Daftar Menu
                  </h3>
                  <p class="mt-1 text-sm text-gray-600">
                    Kelola menu sistem dan akses role
                  </p>
                </div>
                <div class="mt-2 text-sm text-gray-500 sm:mt-0">
                  Total: {{ menus.total }} menu
                </div>
              </div>
            </div>

            <!-- Search Input -->
            <div class="relative mb-4">
              <div
                class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
              >
                <MagnifyingGlassVue class="w-4 h-4 text-gray-400" />
              </div>
              <input
                v-model="search"
                type="text"
                autocomplete="off"
                placeholder="Search data..."
                id="search"
                class="block w-full px-3 py-2.5 pl-10 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
              />
            </div>

            <!-- Table -->
            <div
              class="overflow-hidden bg-white shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
            >
              <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-300">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                      >
                        #
                      </th>
                      <th
                        scope="col"
                        class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 min-w-[150px]"
                      >
                        Menu
                      </th>
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 hidden md:table-cell min-w-[120px]"
                      >
                        Route Name
                      </th>
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 min-w-[120px]"
                      >
                        <span class="hidden sm:inline">Is Main Menu</span>
                        <span class="sm:hidden">Type</span>
                      </th>
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 hidden lg:table-cell"
                      >
                        Role Akses Menu
                      </th>
                      <th
                        scope="col"
                        class="relative py-3.5 pl-3 pr-4 sm:pr-6 min-w-[100px]"
                      >
                        <span class="sr-only">Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <!-- Table Rows -->
                    <tr
                      v-for="(menu, index) in menus.data"
                      :key="menu.id"
                      class="transition-colors duration-150 hover:bg-gray-50"
                    >
                      <td
                        class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-6"
                      >
                        {{ getRowNumber(index) }}
                      </td>
                      <td class="px-3 py-4 text-sm">
                        <div class="flex items-center">
                          <span
                            v-if="menu.ismain == 0"
                            class="mr-2 text-blue-600"
                            >🏠</span
                          >
                          <span v-else class="mr-2 text-green-600">└─ 📄</span>
                          <span
                            :class="
                              menu.ismain == 0
                                ? 'font-semibold text-blue-900'
                                : 'text-green-700'
                            "
                          >
                            {{ menu.namamenu }}
                          </span>
                        </div>
                        <!-- Mobile view: Show route under menu name on small screens -->
                        <div class="mt-1 text-xs text-gray-500 md:hidden">
                          {{ menu.linkurl }}
                        </div>
                      </td>
                      <td
                        class="hidden px-3 py-4 text-sm text-gray-500 whitespace-nowrap md:table-cell"
                      >
                        {{ menu.linkurl }}
                      </td>
                      <td class="px-3 py-4 text-sm whitespace-nowrap">
                        <span
                          v-if="menu.ismain == 0"
                          class="inline-flex items-center px-2 py-1 text-xs font-medium text-blue-800 bg-blue-100 rounded-full"
                        >
                          <span class="hidden sm:inline">🏠 Main Menu</span>
                          <span class="sm:hidden">🏠 Main</span>
                        </span>
                        <span
                          v-else
                          class="inline-flex items-center px-2 py-1 text-xs font-medium text-green-800 bg-green-100 rounded-full"
                        >
                          <span class="hidden sm:inline"
                            >📄 Sub:
                            {{
                              isMain.data.find((main) => main.id == menu.ismain)
                                ?.namamenu || "-"
                            }}</span
                          >
                          <span class="sm:hidden">📄 Sub</span>
                        </span>
                      </td>
                      <td
                        class="hidden px-3 py-4 text-sm whitespace-nowrap lg:table-cell"
                      >
                        <div
                          v-if="
                            menuroles.data.find((mr) => mr.menu_id == menu.id)
                          "
                        >
                          <button
                            @click="showMenuRole(menu)"
                            class="inline-flex items-center px-2.5 py-1.5 text-xs font-medium text-indigo-600 bg-indigo-100 rounded-md hover:bg-indigo-200 hover:text-indigo-700 transition-colors duration-150"
                            title="View Roles"
                          >
                            <BarsIcons class="w-3 h-3" />
                            <span class="ml-1">View</span>
                          </button>
                        </div>
                        <div v-else>
                          <button
                            @click="showRole(menu)"
                            class="inline-flex items-center px-2.5 py-1.5 text-xs font-medium text-purple-600 bg-purple-100 rounded-md hover:bg-purple-200 hover:text-purple-700 transition-colors duration-150"
                            title="Assign Roles"
                          >
                            <RoleIcons class="w-3 h-3" />
                            <span class="ml-1">Assign</span>
                          </button>
                        </div>
                      </td>
                      <td
                        class="relative py-4 pl-3 pr-4 text-sm font-medium text-right sm:pr-6"
                      >
                        <div
                          class="flex items-center justify-end space-x-1 sm:space-x-2"
                        >
                          <!-- Mobile: Show role access button -->
                          <div class="lg:hidden">
                            <div
                              v-if="
                                menuroles.data.find(
                                  (mr) => mr.menu_id == menu.id
                                )
                              "
                            >
                              <button
                                @click="showMenuRole(menu)"
                                class="inline-flex items-center px-2 py-1 text-xs font-medium text-indigo-600 bg-indigo-100 rounded-md hover:bg-indigo-200 hover:text-indigo-700 transition-colors duration-150 sm:px-2.5 sm:py-1.5"
                                title="View Roles"
                              >
                                <BarsIcons class="w-3 h-3" />
                              </button>
                            </div>
                            <div v-else>
                              <button
                                @click="showRole(menu)"
                                class="inline-flex items-center px-2 py-1 text-xs font-medium text-purple-600 bg-purple-100 rounded-md hover:bg-purple-200 hover:text-purple-700 transition-colors duration-150 sm:px-2.5 sm:py-1.5"
                                title="Assign Roles"
                              >
                                <RoleIcons class="w-3 h-3" />
                              </button>
                            </div>
                          </div>
                          <!-- Action Buttons (Edit, Delete) -->
                          <button
                            @click="editMenu(menu.id)"
                            class="inline-flex items-center px-2 py-1 text-xs font-medium text-indigo-600 bg-indigo-100 rounded-md hover:bg-indigo-200 hover:text-indigo-700 transition-colors duration-150 sm:px-2.5 sm:py-1.5"
                            title="Edit"
                          >
                            <EditIcons class="w-3 h-3" />
                            <span class="hidden ml-1 sm:inline">Edit</span>
                          </button>
                          <button
                            @click="deleteRole(menu.id)"
                            class="inline-flex items-center px-2 py-1 text-xs font-medium text-red-600 bg-red-100 rounded-md hover:bg-red-200 hover:text-red-700 transition-colors duration-150 sm:px-2.5 sm:py-1.5"
                            title="Delete"
                          >
                            <DeleteIcons class="w-3 h-3" />
                            <span class="hidden ml-1 sm:inline">Delete</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <Modal
                v-if="isRoleModalOpen"
                v-model:isOpen="isRoleModalOpen"
                :title="`Menu ${selectedRoleMenu?.namamenu}`"
                :menuId="selectedRoleMenu?.id"
                :roles="roles.data"
                :users="users.data"
                :programs="programs.data"
              />
              <ModalMenu
                v-if="isMenuModalOpen"
                v-model:isOpen="isMenuModalOpen"
                :title="`${selectedMenu?.namamenu}`"
                :menuId="selectedMenu?.id"
                :roles="roles.data"
                :programs="programs.data"
                :menuroles="menuroles.data"
                :users="users.data"
              />
            </div>

            <!-- Pagination -->

            <Pagination :data="menus" :updatedPageNumber="updatedPageNumber" />
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>
<script setup>
import { router, useForm, usePage } from "@inertiajs/vue3";
import { computed, ref, watch, defineProps, inject } from "vue";
import MagnifyingGlassVue from "@/Components/MagnifyingGlass.vue";
import EditIcons from "@/Components/Icons/EditIcons.vue";
import DeleteIcons from "@/Components/Icons/DeleteIcons.vue";
import BarsIcons from "@/Components/Icons/BarsIcons.vue";
import InputField from "@/Components/InputField.vue";
import PrimaryBtn from "@/Components/PrimaryBtn.vue";
import InputError from "@/Components/InputError.vue";
import InputLabel from "@/Components/InputLabel.vue";
import Pagination from "@/Components/Pagination.vue";
import Modal from "@/Components/Modal.vue";
import ModalMenu from "@/Components/ModalMenu.vue";
import RoleIcons from "@/Components/Icons/RoleIcons.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import Container from "@/Layouts/Container.vue";
import Header from "@/Components/Header.vue";
import Swal from "sweetalert2";
import vSelect from "vue-select";
const route = inject('route');

const props = defineProps({
  menus: {
    type: Object,
    required: true,
  },
  menuroles: {
    type: Object,
    required: true,
  },
  isMain: {
    type: Object,
    required: true,
  },
  roles: {
    type: Object,
    required: true,
  },
  programs: {
    type: Object,
    required: true,
  },
  users: {
    type: Object,
    required: true,
  },
});
//modal
const isRoleModalOpen = ref(false);
const selectedRoleMenu = ref(null);

const showRole = (menu) => {
  selectedRoleMenu.value = menu;
  isRoleModalOpen.value = true;
};
//Model Show Menu ROle
const isMenuModalOpen = ref(false);
const selectedMenu = ref(null);

const showMenuRole = (menu) => {
  selectedMenu.value = menu;
  isMenuModalOpen.value = true;
};

let search = ref(usePage().props.search || ""),
  pageNumber = ref(1);

let menuUrl = computed(() => {
  let url = new URL(route("menus.index"));
  url.searchParams.append("page", pageNumber.value);
  if (search.value) {
    url.searchParams.append("search", search.value);
  }

  return url;
});

// Computed property for row number calculation with fallbacks
const getRowNumber = computed(() => {
  return (index) => {
    const currentPage = props.menus?.current_page || 1;
    const perPage = props.menus?.per_page || 10;
    return (currentPage - 1) * perPage + index + 1;
  };
});

const updatedPageNumber = (link) => {
  if (link && link.url) {
    try {
      const urlParams = new URLSearchParams(link.url.split("?")[1] || "");
      const page = urlParams.get("page");
      if (page) {
        pageNumber.value = parseInt(page);
      }
    } catch (error) {
      console.error("Error parsing pagination URL:", error);
    }
  }
};

watch(
  () => menuUrl.value,
  (updateMenuUrl) => {
    router.visit(updateMenuUrl, {
      preserveScroll: true,
      preserveState: true,
      replace: true,
    });
  }
);

watch(
  () => search.value,
  (value) => {
    if (value) {
      pageNumber.value = 1;
    }
  }
);
const deleteForm = useForm({});
const deleteRole = (menuId) => {
  Swal.fire({
    title: "Apakah Anda yakin?",
    text: "Menu ini akan dihapus secara permanen!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#dc2626",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Ya, hapus!",
    cancelButtonText: "Batal",
  }).then((result) => {
    if (result.isConfirmed) {
      deleteForm.delete(route("menus.destroy", menuId), {
        onSuccess: () => {},
        onError: () => {
          Swal.fire({
            title: "Gagal!",
            text: "Terjadi kesalahan saat menghapus menu.",
            icon: "error",
            confirmButtonText: "OK",
          });
        },
      });
    }
  });
};

const editMenu = async (menuId) => {
  try {
    const response = await axios.get(`/menus/${menuId}`); // Ambil role berdasarkan ID
    const menu = response.data.menu;
    // Set nilai form dengan data role yang dipilih
    form.id = menu.id;
    form.namamenu = menu.namamenu;
    form.linkurl = menu.linkurl;
    form.ismain = menu.ismain;
    form.isactive = menu.isactive;
    form.icon_main = menu.icon_main;
  } catch (error) {
    console.error("Error fetching role data:", error);
  }
};
const form = useForm({
  id: null,
  namamenu: "",
  linkurl: "",
  ismain: "",
  isactive: "",
  icon_main: "",
});

const submit = () => {
  if (form.id) {
    form.put(route("menus.update", form.id), {
      onSuccess: () => {
        form.reset();
        Swal.fire({
          title: "Berhasil!",
          text: "Data berhasil diperbarui.",
          icon: "success",
          confirmButtonText: "OK",
        });
      },
      onError: () => {
        Swal.fire({
          title: "Gagal!",
          text: "Terjadi kesalahan saat memperbarui data.",
          icon: "error",
          confirmButtonText: "OK",
        });
      },
    });
  } else {
    form.post(route("menus.store"), {
      onSuccess: () => {
        form.reset();
        Swal.fire({
          title: "Berhasil!",
          text: "Data berhasil disimpan.",
          icon: "success",
          confirmButtonText: "OK",
        });
      },
      onError: () => {
        Swal.fire({
          title: "Gagal!",
          text: "Terjadi kesalahan saat menyimpan data.",
          icon: "error",
          confirmButtonText: "OK",
        });
      },
    });
  }
};
</script>
